/*
Copyright © 2021 EPAM Systems, Inc. All Rights Reserved.
All information contained herein is, and remains the property of EPAM Systems, Inc.
and/or its suppliers and is protected by international intellectual property law.
Dissemination of this information or reproduction of this material is strictly
forbidden, unless prior written permission is obtained from EPAM Systems, Inc
*/
import React from 'react';

const input = require('b_')
    .with('input');

export const CheckboxWithLinks = ({
    customLabel,
    id,
    disabled,
    onChange,
    value,
    error,
}) => (
    <div style={{
        display: 'flex',
        flexDirection: 'row',
    }}>
        <input
            id={id}
            required
            disabled={disabled}
            className={input({
                error: !!error,
                checkbox: true,
            })}
            type="checkbox"
            onChange={onChange}
            checked={value}
        />
        {// eslint-disable-next-line jsx-a11y/label-has-associated-control
            <label className={input('label', {
                checkbox: true,
                disabled,
                top: true,
            })} htmlFor={id}/>}
        {customLabel}
    </div>
);

export const Checkbox = ({
    id,
    label,
    value,
    onChange,
    required,
    disabled,
    error,
    mod,
}) => (
    <div className={input('group', { required, ...mod })}>
        <input
            id={id}
            required={true}
            disabled={disabled}
            className={input({
                error: !!error,
                checkbox: true,
            })}
            type="checkbox"
            onChange={onChange}
            checked={value}
        />
        <label className={input('label', {
            checkbox: true,
            disabled,
        })} htmlFor={id}>
            {label}
        </label>
    </div>
);
